import { motion } from 'motion/react';
import { CourseCard } from './CourseCard';
import { StudyChatLauncher } from '@/modules/study-chat';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import { courses } from '@/data/courses';

export function CoursesSection() {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-white mb-4">Course Specializations</h2>
          <p className="text-cyan-300 text-xl">
            Comprehensive curriculum designed for the future of edge computing
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.map((course, index) => (
            <CourseCard
              key={course.title}
              title={course.title}
              description={course.description}
              icon={course.icon}
              index={index}
              url={course.url}
              actions={
                <>
                  <Button
                    className="h-10 w-full bg-transparent border border-cyan-400 text-cyan-400 hover:bg-cyan-400 hover:text-white transition-all duration-300"
                    style={{ boxShadow: '0 0 15px rgba(0, 229, 209, 0.2)' }}
                    onClick={() =>
                      navigate(`/classroom?courseId=${course.course_id}`)
                    }
                  >
                    Open in Classroom
                  </Button>

                  <StudyChatLauncher
                    subjectId={course.course_id}
                    subjectTitle={course.title}
                    maxGroups={5}
                    buttonClassName="h-10"
                  />
                </>
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
}
